<script>
    import { ValidationProvider } from 'vee-validate'

    export default {
    components: {
        ValidationProvider,
    },
    props: {
        vid: {
            type: String,
        },
        rules: {
            type: [Object, String],
            default: '',
        },
        // must be included in props
        check_value: {
            type:  Number,
        },
        unchecked_value: {
            type: Number,
        },
        value: {
            type: Number,
        },

    },
    data: () => ({
        innerValue: null,
    }),
    watch: {
        // Handles internal model changes.
        innerValue(newVal) {
        this.$emit('input', newVal[0])
        },
        // Handles external model changes.
        value(newVal) {
        this.innerValue = newVal
        },
    },
    created() {
        if (this.value) {
        this.innerValue = this.value
        }
    },
    }
</script>
<template>
    <ValidationProvider :name="$attrs.name" :rules="rules" >
        <b-form-group slot-scope="{ valid, errors}" v-bind="$attrs">
            <b-form-checkbox
            :state="errors[0] ? false : valid  ? true : null"
            switch
            v-model="innerValue"
            v-bind="$attrs"
            :value="check_value"
            :unchecked-value="unchecked_value"
        >
            <slot />
        </b-form-checkbox>
        <b-form-invalid-feedback id="inputLiveFeedback">
            {{ errors[0] }}
        </b-form-invalid-feedback>
        </b-form-group>
    </ValidationProvider>
</template>
<style>
</style>